import { render, staticRenderFns } from "./MonthPickerModel.vue?vue&type=template&id=b508abb2&scoped=true"
import script from "./MonthPickerModel.vue?vue&type=script&lang=js"
export * from "./MonthPickerModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b508abb2",
  null
  
)

export default component.exports